<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0">{{ title }}</h3>
                </div>
                <div class="col text-right">
                    <base-button @click.prevent="filterModal = true;" type="primary">
                        Spalten ein/ausblenden
                    </base-button>
                </div>
                <div class="col text-right">
                    <el-input
                        type="search"
                        class=""
                        clearable
                        prefix-icon="el-icon-search"
                        style="width: 250px"
                        placeholder="Suche"
                        v-model="search"
                        aria-controls="datatables"
                    >
                    </el-input>
                </div>
            </div>
        </div>
        <div>
            <modal v-model:show="filterModal" @close="filterModal = false"
                   modal-classes="modal-sm modal-dialog-centered d-flex justify-content-center">

                <div v-for="(column, key) in table" class="ml-3">
                    <el-checkbox v-model="table[key].visible" :label="column.header"></el-checkbox>
                </div>
                <base-button class="resetFilter ml-3" title="zurücksetzen" @click.prevent="resetTableColumns()"
                             type="warning">
                    Zurücksetzen
                </base-button>

                <div class="row ">
                </div>
            </modal>
        </div>
        <div class="table-responsive">
            <el-table type="index"
                      ref="assetsTable"
                      class="table-responsive"
                      :class="type === 'dark' ? 'table-dark': ''"
                      :header-row-class-name="type === 'dark' ? 'thead-dark': ''"
                      :default-sort="{ prop: 'name', order: 'ascending' }"
                      @sort-change="changeSort"
                      :data="filteredAssets">
               <template #empty>
                   <span v-if="loading"><img height="30" class="loader" src="img/loading.gif" alt="loader"></span>
                   <span v-if="!loading">Keine Einträge vorhanden</span>
               </template>
                <el-table-column prop="name" label="Name" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.name.visible">
                    <template v-slot="{ row }">
                        {{ (row.name) ? row.name : '' }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <base-button class="exportCSV" title="exportieren" @click.prevent="exportCSV()"
                         type="success">
                exportieren
            </base-button>
            <div class=""
                 :class="type === 'dark' ? 'bg-transparent': ''">
                <base-pagination v-model="pagination" :total="total" :perPage="perPage"></base-pagination>
            </div>
        </div>
        <base-alert v-if="error.length > 0" type="danger">
            <span class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        </base-alert>
    </div>

</template>
<script>
import UserService from '@/services/user.service';
import Modal from "@/components/Modal";
import BaseAlert from "@/components/BaseAlert";
import * as jsonexport from "jsonexport/dist";
import {
    ElTable,
    ElTableColumn,
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption,
    ElCard,
    ElCheckbox
} from "element-plus";

export default {
    name: 'assets-table',
    components: {
        Modal,
        BaseAlert,
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
        [ElCard.name]: ElCard,
        [ElCheckbox.name]: ElCheckbox,
    },
    props: {
        type: {
            type: String
        },
        title: String
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        filteredAssets() {
            if (this.search === '') {
                this.total = this.assets.length;
                return this.assets.filter((item, idx) => (idx >= this.start && idx < this.start + this.perPage));
            } else {
                const entries = this.assets.filter(item => {
                    let props = Object.values(item);
                    return props.some(prop => !this.search.toLowerCase() || ((typeof prop === 'string') ? prop.toLowerCase().includes(this.search.toLowerCase()) : prop.toString(10).toLowerCase().includes(this.search.toLowerCase())))
                });
                this.total = entries.length;
                return entries.filter((item, idx) => (idx >= this.start && idx < this.start + this.perPage));
            }
        },
    },
    methods: {
        changeSort(sort) {
            this.currentSort = (!sort.prop) ? '' : sort.prop;
            this.currentSortDir = (!sort.order) ? '' : sort.order;
            this.sortTable();
        },
        sortTable() {
            this.assets.sort((a, b) => {
                let modifier = 1;
                if (this.currentSortDir === 'descending') modifier = -1;
                if (a[this.currentSort].toLowerCase() < b[this.currentSort].toLowerCase()) return -1 * modifier;
                if (a[this.currentSort].toLowerCase() > b[this.currentSort].toLowerCase()) return modifier;
                return 0;
            });
        },
        getError(error) {
            if (error.response && error.response.status == '401') {
                this.error = 'you are not logged in!';
            } else if (error.response && error.response.status == '403') {
                this.error = 'you are not permitted!';
            } else {
                this.error =
                    (error.response && error.response.data) ||
                    error.message ||
                    error.toString();
            }
        },
        getAssets() {
            this.loading = true;
            UserService.getAssets().then(
                response => {
                    this.assets = response.data.assets;
                    this.sortTable(this.currentSort);
                    this.total = response.data.assets.length;
                    this.error = '';
                    this.disabled = false;
                    this.$emit("changed", response.data);
                    this.loading = false;
                },
                error => {
                    this.getError(error);
                    this.loading = false;
                }
            );
        },
        openFilter(){
            this.filterModal = true;
        },
        exportCSV() {
            let exported = []
            for (const asset of this.assets) {
                let data = {}
                for (const e in this.table) {
                    if (this.table[e].visible) {
                        data[this.table[e].CSVHeader] = asset[e];
                    }
                }
                exported.push(data);
            }
            jsonexport(exported, {rowDelimiter: ';' }, (err, csv) => {
                let element = document.createElement('a');
                element.setAttribute('href', 'data:text/csv;charset=utf-16,' + encodeURIComponent(csv));
                element.setAttribute('download', 'Assets.csv');
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            } )
        },
        getTableColumns() {

            if (sessionStorage.getItem('assetsTable') !== null) {
                return JSON.parse(sessionStorage.getItem('assetsTable'));
            } else {
                return {
                    name: {visible: true, header: "Name", key: "name", CSVHeader: 'Name'},
                };
            }
        },

        resetTableColumns() {
            this.table = {
                name: {visible: true, header: "Name", key: "name", CSVHeader: 'Name'},
            };
            sessionStorage.removeItem('assetsTable');
        }

    },
    created() {
        this.getAssets();
        this.table = this.getTableColumns();
    },
    data() {
        return {
            assets: [],
            loading: false,
            modal: false,
            filterModal: false,
            currentSort: 'name',
            currentSortDir: 'ascending',
            search: '',
            disabled: true,
            error: '',
            newRequest: '',
            pagination: 1,
            total: 0,
            start: 0,
            perPage: 5,
            table: {},
        }
    },
    watch: {
        pagination() {
            this.start = (this.pagination - 1) * this.perPage;
        },
        table: {
            handler(value) {
                sessionStorage.setItem('assetsTable', JSON.stringify(value));
            }, deep:true
        } ,
    }
}
</script>
<style scoped lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}

.loader {
    height: 100%;
}

.loaderInfo {
    padding: 0;
    margin: 0;
    background: white;
    height: 4em;
}

.ck-editor__editable {
    min-height: 150px;
}
.exportCSV {
    line-height: 0.5!important;
    height: 36px;
    overflow: hidden!important;
}

</style>

